import Header from "~/views/Header";
import Router from "~/Router";

function App() {
  return (
    <div className="application">
      <Header />
      <Router />
    </div>
  );
}

export default App;
